import axios from "axios";
export { outfittingActions };
axios.defaults.withCredentials = true;
function outfittingActions() {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;
  return {
    getOutfittingQueryParams,
    exportData,
  };
  async function getOutfittingQueryParams(
    pageNumber: number,
    pageSize: number,
    tenant: string,
    description?: string,
    code?: string
  ) {
    
    return axios.get(`${baseUrl}/masterdatavehicle/outfitting`, {
      params: {
        pageNumber: pageNumber,
        pageSize: pageSize,
        tenant:tenant,
        description: description,
        code: code,
      },
    });
  }

  async function exportData(tenant: string,description: string, code: string) {
    const params = {tenant:tenant, description: description, code: code };
    return axios.get(
      `${baseUrl}/masterdatavehicle/outfitting/excel`,
      {
        params,
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );
  }
}
